import { render, staticRenderFns } from "./OnlineVideos.vue?vue&type=template&id=48d86b2c"
import script from "./OnlineVideos.vue?vue&type=script&lang=js"
export * from "./OnlineVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports